import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ManageCategory from "../components/ManageCategory";

const ManageCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Manage Categories' />

        <ManageCategory />

      </MasterLayout>
    </>
  );
};

export default ManageCategoryPage;
